
import { Injectable } from '@angular/core';
import {
  Resolve
} from '@angular/router';
import { catchError, forkJoin, map, Observable, of, take } from 'rxjs';
import { VendorStore } from 'src/app/features/common-data/stores/vendor.store';
import { CountryStore } from '../stores/country.store';
import { TransferMediumStore } from '../stores/transfer-medium.store';
import { VendorGroupStore } from '../stores/vendor-group.store';


@Injectable({
  providedIn: 'root',
})
export class VendorsResolver implements Resolve<boolean> {
     constructor(
    private vendorStore: VendorStore,
    private countryStore: CountryStore,
    private vendorGroupStore: VendorGroupStore,
    private transferMediumStore: TransferMediumStore
  ) {}

  resolve(): Observable<boolean> {
    this.vendorStore.loadPagedVendors();
    this.transferMediumStore.loadTransferMediums();
      
     return forkJoin({
      countries: this.countryStore.loadCountries().pipe(take(1)),
      groups:    this.vendorGroupStore.loadVendorGroups().pipe(take(1)),
      vendors:   this.vendorStore.loadVendors().pipe(take(1)),
    }).pipe(
      map(() => true),
      catchError(err => {
        console.error('Resolver error', err);
        // Navigation nicht blockieren:
        return of(true);
      })
    );
  }
}